var exports = {
  "kL": "x8b4e8595--b68daf--container",
  "Sl": "x8b4e8595--b68daf--image",
  "q9": "x8b4e8595--b68daf--price",
  "h_": "x8b4e8595--b68daf--description",
  "h6": "x8b4e8595--b68daf--two-rows",
  "x1": "x8b4e8595--b68daf--full-description",
  "BI": "x8b4e8595--b68daf--favorite",
};

module.exports = exports;
